export enum AppPermissionType
{
    Scope = "Scope",
    Role = "Role",
}

export function appPermissionTypeToNumber(permissionType: AppPermissionType): number {
    switch (permissionType) {
        case AppPermissionType.Scope:
            return 0;
        case AppPermissionType.Role:
            return 1;
        default:
            throw new Error(`Unknown AppPermissionType: ${permissionType}`);
    }
}